"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Portal = void 0;

const react_1 = require("react");

const react_dom_1 = __importDefault(require("react-dom"));
/**
 * The portal component will check if there is a HTMLElement with the given
 * portal name, or create that element when it is not found, and render the
 * children in that element using React's portal API.
 *
 * @important If you use multiple portals and you need to ensure the correct
 * stacking order for your portals, please make sure that the portals already
 * exist in your HTML before React boots.
 */


exports.Portal = _a => {
  var {
    portal = 'portal'
  } = _a,
      props = __rest(_a, ["portal"]);

  const [element, setElement] = react_1.useState(null);
  react_1.useEffect(() => {
    let element = window.document.getElementById(portal);

    if (!element) {
      element = window.document.createElement('div');
      element.id = portal;
      window.document.body.appendChild(element);
    }

    setElement(element);
  }, [portal]);
  return element ? react_dom_1.default.createPortal(props.children, element) : null;
};

exports.default = exports.Portal;